import { IAppState } from 'src/app/store/state/app.state';
import { Subscription } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { HttpParams } from '@angular/common/http';
import * as AuthActions from '../../../store/auth/actions/auth.actions';
import { AuthRequestReset } from '../../../models/auth';
import { ActivatedRoute, Data } from '@angular/router';
import { getResetPasswordState } from 'src/app/store/auth/selectors/auth.selectors';
import { IResetPasswordState } from 'src/app/store/state/auth.resetpassword.state';
import { AppConfig } from 'src/app/app.config';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
    forgotPasswordForm: UntypedFormGroup;
    email: UntypedFormControl;
    formTitle = 'Recover your password';
    forgotFailText = 'Unable to send password reset.';
    formInstruction = "Enter your email and we'll send you instructions on how to reset your password";
    forgotSuccessText = 'Password reset request completed. Please check your email for further instructions.';
    showSpinner = false;
    forgotPasswordFail = false;
    forgotPasswordSuccess = false;
    authSubscription: Subscription;
    isNewUserPassword = false;

    constructor(private store: Store<IAppState>, private route: ActivatedRoute, private appConfig: AppConfig) { }

    ngOnInit() {
        this.email = new UntypedFormControl(null, [Validators.required, Validators.email]);
        this.forgotPasswordForm = new UntypedFormGroup({
            email: this.email
        });

        this.authSubscription = this.store.pipe(select(getResetPasswordState))
            .subscribe((state: IResetPasswordState) => {
                if (!state) {
                    return;
                }

                this.forgotPasswordFail = (state.resetFail && !state.authenticated);
                this.forgotPasswordSuccess = (!state.resetFail && state.resetSuccess);
                this.showSpinner = state.loading;
                this.enableDisableForm(this.forgotPasswordForm, !state.loading);
            });

        // Check if we are instead creating a password for a newly onboarded client
        this.route.data.subscribe((data: Data) => {
            if (data.isNewUserPassword) {
                this.isNewUserPassword = true;
                this.setNewUserText();
            }
        });
    }

    private enableDisableForm(form: UntypedFormGroup, enable: boolean) {
        if (form) {
            if (enable) {
                form.enable();
            } else {
                form.disable();
            }
        }
    }

    setNewUserText() {
        this.formTitle = 'Set your password';
        this.forgotSuccessText = 'Set password request completed. Please check your email for further instructions.';
        this.formInstruction = "Enter your email and we'll send you instructions on how to set your password.";
    }

    onSubmit() {
        let httpParams = new HttpParams();
        const paramsObject: AuthRequestReset = {
            siteId: <string>this.appConfig.getEnvironment().siteId,
            emailAddress: this.email.value,
            clientId: <string>this.appConfig.getEnvironment().clientId,
            managerId: <string>this.appConfig.getEnvironment().managerEntityId
        };

        for (const key in paramsObject) {
            if (key) {
                httpParams = httpParams.set(key, paramsObject[key]);
            }
        }
        this.store.dispatch(new AuthActions.RequestReset(httpParams));
    }

    ngOnDestroy() {
        this.store.dispatch(new AuthActions.RequestResetInit);
        this.authSubscription.unsubscribe();
    }
}
